import { axiosInstance } from '@/shared/api/instance';
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { InvitedPlayersResponse, QrResponse } from '../api/invite.types';

export const fetchQrCode = createAsyncThunk<QrResponse, void, { rejectValue: string }>(
  'invite/fetchQrCode',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<QrResponse>('/app/invites/get-urls');
      return response.data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  },
);
export const fetchInvitedPlayers = createAsyncThunk<
  InvitedPlayersResponse,
  void,
  { rejectValue: string }
>('invite/fetchInvitedPlayers', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<InvitedPlayersResponse>('/app/invites/players');
    return response.data;
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.message || 'Ошибка при получении списка приглашенных',
    );
  }
});
